

const Header = ({msg}) => {
  return (
    <header className=" mt-24 bg-gray-900 bg-opacity-80 rounded-lg mx-5 my-4 text-3xl text-center text-gray-100">
      <p>{ msg }</p>
    </header>
  )
}

export default Header